import Resource from "axios-resource";

export default class AuthResource extends Resource {
    URL = `/v1/auth`;

    constructor(props) {
        super(props);
    }

    login(attrs, options) {
        this._url = this.URL + '/login?expand={expand}';
        return this.sync('post', attrs, options);
    };
}



// WEBPACK FOOTER //
// ./src/resources/authResource.js